// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3FCpA","footer":"ModalFilter_footer__3-AsC"};